import { z } from 'zod';

export const reportSchema = z.object({
    name: z.string().min(1, 'Name is required'),
    email: z.email('Invalid email address'),
});

export type ReportFormValues = z.infer<typeof reportSchema>;